var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat307(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cat_307"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_307",
    "data-name": 307,
    className: "cls-2",
    d: "M74.7,6.05c7.08,7.73,2.29,23-2,36.57C65.75,65,48.55,100.47,31.22,98a15,15,0,0,1-9.33-5.73C18,87,18.2,79.27,29.21,45.54,33.09,33.66,36.32,20.23,45.31,11,52.5,3.61,66.23-3.2,74.7,6.05Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat307);
export default __webpack_public_path__ + "static/media/cat_307.f3d8284bdddfcb7df9f86c9627c5b461.svg";
export { ForwardRef as ReactComponent };